var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M527.6672 325.8368c19.8144 0 35.84-15.6672 35.84-34.9184a35.3792 35.3792 0 0 0-35.84-34.9184H240.64C220.8768 256 204.8 271.616 204.8 290.9184c0 19.2512 16.0768 34.9184 35.84 34.9184h287.0272z m14.336 195.4816c19.8144 0 35.84-15.616 35.84-34.9184a35.3792 35.3792 0 0 0-35.84-34.9184H240.6912c-19.8144 0-35.8912 15.616-35.8912 34.9184 0 19.3024 16.0768 34.9184 35.84 34.9184h301.3632z m147.7632-132.6592l-44.3392 68.7104a34.3552 34.3552 0 0 0 11.264 48.128c16.8448 10.24 38.9632 5.3248 49.5104-11.008l56.32-87.2448a34.0992 34.0992 0 0 0 0-37.1712l-56.32-87.2448a36.4544 36.4544 0 0 0-49.4592-11.008 34.3552 34.3552 0 0 0-11.264 48.128l44.288 68.7104zM721.3568 716.8c19.8144 0 35.84-15.616 35.84-34.9184a35.3792 35.3792 0 0 0-35.84-34.9184H240.6912c-19.8144 0-35.8912 15.6672-35.8912 34.9184 0 19.3024 16.0768 34.9184 35.84 34.9184h480.768z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ea4305171738f8f1e0355b0193278de8.svg";
export { ForwardRef as ReactComponent };